import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';

/**
 * @component PaperComponent
 * @param { Object } props
 * @returns { JSX.Element }
 */
function PaperComponent(props) {
	return (
		<Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
			<Paper {...props} />
		</Draggable>
	);
}

export default PaperComponent;
